import FilterHelper from "../helpers/filterHelper";
import { axiosGet, axiosPatch } from "./axiosService";

const baseTransactionURI = "transactions";

export class TransactionService {
  getTransactionCount = () => {
    return axiosGet(null, `${baseTransactionURI}/CountUnconfirmed`);
  };

  getTransactionsById(
    id,
    loanId = null,
    currentPage = 1,
    perPage = 10,
    showCancelled = false,
    transactionTypeCategories = []
  ) {
    let url = `${baseTransactionURI}?`;
    if (id) url += `UserId=${id}&`;
    if (loanId) url += `LoanId=${loanId}&`;
    transactionTypeCategories.forEach((category) => {
      url += `TransactionTypeCategories=${category}&`;
    });

    url += `Paging.CurrentPage=${currentPage}&Paging.PerPage=${perPage}&ShowCancelled=${showCancelled}`;

    return axiosGet(null, url);
  }

	confirmTransaction(correlationId, shouldTransferMoney = true) {
		return axiosPatch(`${baseTransactionURI}/${correlationId}/confirm`, {
			shouldTransferMoney: shouldTransferMoney,
		});
	}

  declineTransaction(correlationId) {
    return axiosPatch(`${baseTransactionURI}/${correlationId}/decline`, {});
  }

  cancelTransaction(coupleId) {
    return axiosPatch(
      `${baseTransactionURI}/${coupleId}/cancel-investments`,
      {}
    );
  }

	cancelDeposit(correlationId) {
		return axiosPatch(`${baseTransactionURI}/deposits/${correlationId}/cancel`, {});
	}

	reconcileHyperPayTransaction(correlationId) {
		return axiosPatch(`${baseTransactionURI}/${correlationId}/hyperpay-reconcile`, {});
	}

	getTransactions(filter, currentPage = 1, perPage = 10) {
		let query = filter ? FilterHelper.mapToParams(filter) : null;
		query = query?.replace("&", "");
		return axiosGet(
			null,
			`${baseTransactionURI}${query ? `?${query}&` : '?'
			}Paging.CurrentPage=${currentPage}&Paging.PerPage=${perPage}`
		);
	}

  exportAsCsv(urlQuery) {
    let query = urlQuery ? FilterHelper.mapToParams(urlQuery) : null;
    query = query?.replace("&", "");
    return axiosGet(
      null,
      `${baseTransactionURI}/Export${query ? "?" + query : ""}`,
      null,
      "blob"
    );
  }

  exportAsPdf(urlQuery) {
    let query = urlQuery ? FilterHelper.mapToParams(urlQuery) : null;
    query = query?.replace("&", "");
    return axiosGet(
      null,
      `${baseTransactionURI}/Export/pdf${query ? "?" + query : ""}`,
      null,
      "blob"
    );
  }
}
